import { render, staticRenderFns } from "./ReadMoreModal.vue?vue&type=template&id=de53e8e4&scoped=true"
import script from "./ReadMoreModal.vue?vue&type=script&lang=js"
export * from "./ReadMoreModal.vue?vue&type=script&lang=js"
import style0 from "./ReadMoreModal.vue?vue&type=style&index=0&id=de53e8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53e8e4",
  null
  
)

export default component.exports